import { IUIState } from '../../../types/reducers';
import { EPublishTermsStatus } from '../../../types/reducers/publishTerms';

export const defaultState: IUIState = {
  publishTerms: {
    status: EPublishTermsStatus.initial,
  },
};
